import React from "react";
import "./DesktopLiveMatches.css";

const DesktopLiveMatches = ({
  matches = [],
  getMatchId,
  getMatchName,
  openMatch,
}) => {
  if (!matches.length) {
    return null;
  }

  return (
    <section
      className="desktop-live-matches"
      aria-label="Live matches"
    >
      <div className="desktop-live-track">
        {matches.map((match, index) => {
          const matchId =
            getMatchId?.(match) ?? index;

          const matchName =
            getMatchName?.(match) ??
            match.event_name ??
            match.name ??
            "Live match";

          return (
            <button
              key={`${matchId}-${index}`}
              type="button"
              className="desktop-live-match"
              title={matchName}
              onClick={() => openMatch?.(match)}
            >
              <i
                className={`d-icon ${
                  match.tickerSport === "cricket"
                    ? "icon-4"
                    : match.tickerSport === "tennis"
                    ? "icon-2"
                    : "icon-1"
                }`}
                aria-hidden="true"
              />

              <span>{matchName}</span>
            </button>
          );
        })}
      </div>
    </section>
  );
};

export default DesktopLiveMatches;